<template>
  <div class="container-login d-flex align-items-center">
    <div class="card card-login align-items-stretch">
      <div class="card-login-logo text-center pt-4">
        <img src="../../img/vendoscope-logo.png">
      </div>

      <login-index v-if="step == 'index'" @userActive="onUserActive"></login-index>

      <login-password
        v-if="step == 'password'"
        :auth="auth"
        :password_sent="password_sent"
        :password_debug="password_debug"
        @sms="onSms"
        @cancel="step = 'index'"></login-password>

      <login-sms v-if="step == 'sms'" @cancel="step = 'index'"></login-sms>
    </div>
  </div>
</template>

<script>
  import LoginIndex from '../components/login/index.vue'
  import LoginPassword from '../components/login/password.vue'
  import LoginSms from '../components/login/sms.vue'
  export default {
    metaInfo: {title: 'Авторизация'},
    data () {
      return {
        step: 'index',
        auth: {},
        password_sent: null,
        password_debug: null,
      }
    },
    components: {
      LoginIndex,
      LoginPassword,
      LoginSms,
    },
    methods: {
      onLogin () {
        this.$router.push('/')
      },
      onUserActive (auth, data) {
        this.auth = auth
        this.password_sent = data.password_sent
        this.password_debug = data.password_debug
        this.step = 'password'
      },
      onSms (auth) {
        this.auth = auth;
        this.step = 'sms'
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";

  .container-login {
    width: 100%;
    background-color: desaturate(darken($info, 8%), 30%);
    @include gradient-radial(desaturate(darken($primary, 10%), 50%), desaturate(darken($info, 10%), 30%));
  }
  .card-login {
    width: 90%;
    max-width: 26rem;
    margin: auto;
    font-size: $font-size-lg;
    //border-top: 4px solid $primary;
    box-shadow: 0 5px 10px rgba(#000, .5);
    .card-body {
      @include media-breakpoint-up(sm) {
        padding: 2rem;
      }
    }
    label {
      font-weight: $font-weight-bold;
    }
    .form-actions {
      position: relative;
    }
    .alert-danger {
      text-align: left;
      background: transparent;
      border: 1px solid #dd0200;
      color: inherit;
      margin-top: 23px;
      margin-bottom: 0;
      transition: background-color 2s ease-out;
      &.new {
        transition-duration: 0s;
        background-color: theme-color-level('danger', -10);
      }
      h4 {
        font-size: 1em;
        font-weight: bold;
      }
    }
  }
  .card-login-logo {
    img {
      width: 100%;
      max-width: 180px;
      height: auto;
    }
  }
  .card-login-title {
    margin-top: 0;
    font-size: $display4-size;
    font-weight: $display4-weight;
    margin-bottom: map-get($spacers, 3);
    text-align: center;
  }
  .validation-errors {
    margin-top: 0;
    margin-bottom: 2em;
    line-height: 1.43;
    letter-spacing: 0.4px;
  }
  .text-inform {
    color: #a3a3a3;
    margin-top: -1em;
    line-height: 1.43;
    letter-spacing: 0.4px;
    p {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/login.vue